import { Layout } from "common/Layout";
import dynamic from "next/dynamic";
const InstitutionsAboutSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsAboutSection/InstitutionsAboutSection"
    ),
  {
    ssr: false
  }
);
const InstituteTable = dynamic(
  () => import("common/Components/InstituteTable/InstituteTable"),
  {
    ssr: false
  }
);
const Featured = dynamic(
  () => import("common/Components/InstituteFinder/InstituteFinder"),
  {
    ssr: false
  }
);

const InstitutionsInformationSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsInformationSection/InstitutionsInformationSection"
    ),
  {
    ssr: false
  }
);

const InstitutionsProgramBox = dynamic(
  () =>
    import("common/Components/InstitutionsProgramBox/InstitutionsProgramBox"),
  {
    ssr: false
  }
);

const InstitutionsEligibleCriteriaSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsEligibleCriteriaSection/InstitutionsEligibleCriteriaSection"
    ),
  {
    ssr: false
  }
);
import { Institutes, ProgramNames } from "helpers/InstitutesData";
export const EngineeringProgram = () => {

  return (
    <>
      <InstitutionsAboutSection
        name=""
        tag="Professional Year Program Engineering at a Glance"
        about={[
          `Professional Year Program in Engineering was developed by EEA (Engineering Education Australia). This 44 week program helps international engineering graduates gain vital insights into the Australian workplace demands, foster their employability skills and thus makes them employment ready.`,
          `It is a comprehensive program comprising extensive training and an internship placement making students job ready in the Australian workspace.`,
          `Moreover, upon successful completion of the program candidates are eligible for 5 extra points on Department of Home Affairs points test.`,
        ]}
        image="/assets/images/py-programs-2.webp"
        price={'Price – A$15,500'}
        duration="44 weeks (minimum) including 32 weeks training in-class and 12 weeks internship placement."
        location="Adelaide, Brisbane, Canberra, Darwin, Hobart, Melbourne, Sydney, Perth"
        industry="Engineering"
        isProgram={true}
      />
      {/* <ProgramFinder /> */}
      <InstituteTable />
      <Featured Institutes={Institutes} ProgramNames={ProgramNames} />
      <InstitutionsEligibleCriteriaSection
        eligibleCriteria={[
          `Candidates must have completed an undergraduate or post-graduate engineering award in Australia.`,
          `Candidates must hold or have 
      <a class="cp-links" href="https://www.aussizzgroup.com/skilled-graduate-visa-485" target="_blank">
      applied for visa 485 (Temporary graduate visa)
      </a> 
      with a minimum of 12 months validity.`,
          `To prove proficiency in English, candidates must have an overall score of 6 in IELTS with a minimum score of 5 in each band OR a minimum overall score of 50 in PTE Academic with a minimum of 36 in all bands of the exam`,
          `Candidates are required to furnish a valid skills assessment from Engineering Education Australia.`,
        ]}
      />
      <InstitutionsProgramBox />
      <InstitutionsInformationSection
        title2="Why Aussizz Group?"
        institutionsInformations={[
          {
            name: `Avail Scholarship through us`,
            icon: '/assets/Icons50/industryv1.webp',
          },
          {
            name: `We have enriched the lives of over 20,000 successful clients`,
            icon: '/assets/Icons50/Employee-Unwind-Session.webp',
          },
          {
            name: `Reward on referring a friend`,
            icon: '/assets/Icons50/studentv1.webp',
          },
          {
            name: `One FREE consultation`,
            icon: '/assets/Icons50/system.webp',
          },
          {
            name: `Free PTE Materials `,
            icon: '/assets/Icons50/system.webp',
          },
        ]}
      />

    </>
  );
};

EngineeringProgram.getLayout = Layout;
EngineeringProgram.layoutOptions = {
  pageTitle:
    "Engineering Professional - Professional Year Program | Australia | Aussizz Group",
  pageDescription:
    "Do you hold an engineering degree from Australia? Boost your career prospects by enrolling in the Engineering Professional Year (PY) Program. 44 weeks (minimum) including 32 weeks training in-class and 12 weeks internship placement",
  pageKeywords:
    "Professional Year Program,py ,Professional Year ,engineering degree, 44-week program, Aussizz Group, Australia",
  imageUrl: "/assets/images/py-programs-2.webp"
};
